var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('Dialog',{attrs:{"warning":_vm.message,"label-cancel":_vm.labelCancel,"label-confirm":"Confirmar"},on:{"confirm":_vm.handlerConfirm,"cancel":_vm.handlerClose}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }